export enum ELoginCompletionMethod {
  BACK_OFFICE = 'backoffice',
  EMAIL_OTP = 'email_otp',
  PASSWORD = 'password',
  RESTORE_BACK_OFFICE = 'restore_backoffice',
  RESTORE_EMAIL_OTP = 'restore_email_otp',
  RESTORE_NONE = 'restore_none',
  RESTORE_PASSWORD = 'restore_password',
}
